<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
import StrIsoIzlemKriterleriBirim from "@/models/StrIsoIzlemKriterleriBirim"; import Swal from "sweetalert2";
import forminput from "@/router/views/FormComponet/forminput.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import store from "@/state/store";
export default {
  mixins: [Api, Sabit, StrIsoIzlemKriterleriBirim],
  page: {
    title: "Birim İyileştirmeleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,  forminput, BirimSecimi
  },
  data() {
    return {
      title: "Birim İzleme Kriterleri",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Kalite Yönetim Sistemi (ISO 9001) Çalışmaları",
        },
        {
          text: "Birim İzleme Kriterleri",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      Filter: {
        Birimid: null,
        Kriterid: null,
        Onay: null
      },
      Userid: store.getters["auth/TokenUserId"],  
    };
  },

  methods: {
    Get() { this.FilterGet() },
    FilterGet() {

      this.$v.Filter.$touch();
      if (!this.$v.Filter.$invalid) {
        var Filter = ""
        if (this.Filter.Kriterid != null) { Filter += "&Kriterid=" + this.Filter.Kriterid }
        if(this.Filter.Onay != null){ Filter += "&Onay=" +this.Filter.Onay}
        if (this.Filter.Birimid != null) { Filter += "&Birimid=" + this.Filter.Birimid }
        this.ActionsFilterGet({ Service: "StrIsoIzlemKriterleriBirim", Page: this.Page, Filter: Filter }).then((res) => {
          this.TableData = res.Data;
          this.Page.PageDataSize = res.TotalCount;
        });
      }
    },  
    Guncelle(FormData){
      delete FormData.Id
      this.Post("StrIsoIzlemKriterleriBirim", FormData) 
    },
    OnayDegistir(Data, durum) { 
      Swal.fire({
        title: "Onay " + (durum == false ? 'İptal' : ''),
        text: "Seçtiğiniz Tetkiğin onay durumu değiştiriliecek.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((result) => {
        if (result.value) {
          Data.Onay = durum
          this.Update("StrIsoIzlemKriterleriBirim", Data, "Onay durumu değiştirildi")
        }
      });

    },
       
  },
};
</script>
<style scoped>
tbody > tr:nth-of-type(2n){
  --bs-table-accent-bg: none;
}

</style>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
 
          
                  <forminput class="col-md-3" 
                  :FormDataType="FormDataType.Onay"
                  :Value="Filter.Onay"
                  :v="$v.Filter.Onay"
                  @input="Filter.Onay = $event"
                />
                <BirimSecimi class="mb-3 col-md-3" :title="FormDataType.Birimid.FieldTitle" :sutun="'0'" 
                  :title_position="'mb-3'" :selected="Filter.Birimid" :labels_lg="'3'" :v="$v.Filter.Birimid"
                  :multiple="false" :BirimTipId="null" @Secilmis_Idler="Filter.Birimid = $event" :YetkiKontrol=1 />

                <div class="col-sm-6 ">
                  <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2 mt-4" @click="FilterGet()"> <i
                      class="mdi mdi-text-search me-1"></i>Filtreleme</button>
                </div>

 
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Süreç</th>
                      <th>Sorumlu Birim</th>
                      <th>İzleme Kriteri No</th>  
                      <th>İzleme Kriteri</th>
                      <th>Veri</th>
                      <th>İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id"  >
                      <th scope="row">{{ Data.Surec }}</th>
                      <td>{{ Data.Birim }}</td> 
                      <td>{{ Data.No }}</td>
                      <td>{{ Data.Kriter }}</td>
                      <td> 
      <b-form-input  v-model="Data.Veri" ></b-form-input> 
                      </td>
                       
                      <td>
                        <div class="action-is w-100 d-flex justify-content-center align-items-center">
                         

                          <i class="fas fa-save" @click="Guncelle(Data)" v-if=" Data.Id == '00000000-0000-0000-0000-000000000000'"></i>

                          <i class="fas fa-check" @click="OnayDegistir(Data, true)" v-if="!Data.Onay && Data.Id != '00000000-0000-0000-0000-000000000000'"></i>
                          <i class="fas fa-times" @click="OnayDegistir(Data, false)" v-if="Data.Onay"></i> 

                          <i class="fas fa-trash-alt" @click="Delete('StrIsoIzlemKriterleriBirim', Data.Id)" v-if="!Data.Onay && Data.Id != '00000000-0000-0000-0000-000000000000'" ></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
 
    </Layout>
  </Loader>
</template>
